<template>
	<div class="upload-img-box-comp">
		<div v-for="(item, index) in updatedImgs" :key="index" class="img-box item-box">
			<el-image class="added-img" :src="item" fit="cover" :preview-src-list="[item]"></el-image>
            <div class="delete-icon">
                <i @click.stop="delImg(index)" class="el-icon-delete"></i>
            </div>
		</div>
		<div v-loading="uploading" v-if="updatedImgs.length < maxImgs" @click="clickUploadFn" class="add-img-box item-box">
            <i class="add-cion el-icon-plus"></i>
		</div>
        <upload-img ref="uploadFile" uploadType="img" :accept="['.jpg','.png','.jpeg']" :multiple="false" uploadSize="5mb" @uploadSucess="uploadSucess" @uploadError="uploadError" @beforeUpload="beforeUpload"></upload-img>
	</div>
</template>

<script>
	/*
	 * 图片上传组件
	 * @property {Number} maxImgs 最多显示照片数量
	 * @property {Number} maxSize 单张照片最大大小，单位mb
	 * @property {Boolean} canPreviewPic 是否可以预览图片
	 * @event {Function} changeImgs updatedImgs改变
	 * @event {Function} addImg 添加图片
	 * @event {Function} deleteImg 删除图片
	*/
    import uploadImg from '@/components/newUpload/upload.vue'

	export default{
		props:{
			maxImgs: { // 最多显示照片数量
				type: Number,
				default: 4
			},
			maxSize: { // 单张照片最大大小，单位mb
				type: Number,
				default: 5
			},
			canPreviewPic: { // 是否可以预览图片
				type: Boolean,
				default: false
			}
		},
        components: {
            'upload-img': uploadImg,
        },
		data(){
			return {
				updatedImgs:[], // 已上传图片列表
                uploading: false,// 加载中
			}
		},
		methods: {
			delImg(imgIndex){
                this.$emit('deleteImg',{oldImgs:this.updatedImgs, delIndex: imgIndex})
				this.updatedImgs.splice(imgIndex,1)
				this.$emit('changeImgs',this.updatedImgs) // 改变updatedImgs列表
            },
			clickUploadFn(){
                if(this.uploading) return
                this.$refs.uploadFile.uploadFile()
            },
            beforeUpload(){
                this.uploading = true
            },
            uploadError(e){
                // console.log('uploadError-e:',e)
                this.uploading = false
            },
            uploadSucess(e){
                // console.log('uploadSucess-e:',e)
                let imgUrl = e[0].url
                this.updatedImgs.push(imgUrl)
                this.$emit('addImg',imgUrl)
                this.$emit('changeImgs',this.updatedImgs) // 改变updatedImgs列表
                this.uploading = false
            }
		}
	}
</script>

<style scoped lang="less">
	.upload-img-box-comp{
		display: flex;
		gap: 20px;
		flex-wrap: wrap;
		.item-box{
			width: 150px;
			height: 150px;
			border-radius: 8px;
			background: #FFFFFF;
		}
		.add-img-box{
			display: flex;
			justify-content: center;
			align-items: center;
			border: 1px solid #FAFAFA;
            background: #f4f6f7;
            cursor: pointer;
			.add-cion{
				// width: 42px;
				// height: 42px;
                color: #969798; 
                font-size: 50px;
                font-weight: 600;
			}
		}
		.img-box{
			position: relative;
			.added-img{
				width: 100%;
				height: 100%;
				border-radius: 8px;
			}
			.delete-icon{
                border-radius: 50%;
                border: 1px solid #858585;
                background: #fff;
                cursor: pointer;
				width: 28px;
				height: 28px;
				position: absolute;
				right: -12px;
				top: -12px;
                font-size: 16px;
                font-weight: 800;
                text-align: center;
                line-height: 28px;
			}
		}
	}
</style>